import { formatMoney } from 'accounting'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/pro-solid-svg-icons'

import { ListItem, StatusBadge, Text } from '@domain-group/suit-theme'

import useCampaignQuote from '@hooks/useCampaignQuote'

import { statusColors } from '@functions/status'

import type { CampaignQuoteModel, UserModel } from '@models/types'

type CompactListProps = {
  campaignQuote: CampaignQuoteModel,
  currentUser: UserModel,
  href: string | null,
  isCampaignManager: boolean,
}

const CompactList = (props: CompactListProps) => {
  const {
    campaignQuote,
    campaignQuote: {
      id, priority_campaign_user_ids: priorityUserIds, title, total,
    },
    currentUser,
    href,
    isCampaignManager,
  } = props

  const { campaign, status } = useCampaignQuote(campaignQuote)
  // @ts-expect-error TS2339
  const { address, suburb_name } = campaign

  const isPriorityCampaignForCurrentUser = priorityUserIds?.includes(currentUser.id)

  return (
    // @ts-expect-error TS2339
    <ListItem.Compact
      // @ts-expect-error TS7053
      contentRight={<StatusBadge color={statusColors[status.key]} ghost text={status.title} />}
      href={href}
    >
      {isPriorityCampaignForCurrentUser && !isCampaignManager && (
        <Text
          color="blue"
          display="inline-block"
          fontSize="xsmall"
          marginRight="medium"
        >
          <FontAwesomeIcon icon={faStar} />
        </Text>
      )}

      {isCampaignManager ? `#${id} - ${title} (${formatMoney(total)})` : `${address}, ${suburb_name}`}
      {/*
     // @ts-expect-error TS2339 */}
    </ListItem.Compact>
  )
}

export default CompactList
